import React, {useState, useEffect, useCallback} from 'react';
import {API_ENDPOINTS} from "../../../apiConfig";
import PartCategoryModal from "../../../components/PartCategoryModal";
import API from "../../../utils/API";
import moment from 'moment';
import {useTranslation} from 'react-i18next';
import Forms from "../../../components/Forms";
import DeleteIconButton from "../../../components/Forms/DeleteIconButton";
import EditIconButton from "../../../components/Forms/EditIconButton";
import {useModal} from "../../../contexts/ModalContext";
import AdminDataView from "../../../components/AdminDataView";

const PartCategories = () => {
    const [categories, setCategories] = useState([]);
    const {t} = useTranslation();
    const [error, setError] = useState();
    const {openModal, confirm} = useModal();

    const fetchCategories = useCallback(async () => {
        const response = await API.get(API_ENDPOINTS.part.categories);
        setCategories(response.data);
    }, []);

    useEffect(() => {
        fetchCategories();
    }, [fetchCategories]);

    const columns = [
        {
            key: 'name',
            name: t('name'),
            renderCell: ({row}) => row.name
        },
        {
            key: 'code',
            name: t('categoryCode')
        },
        {
            key: 'description',
            name: t('description')
        },
        {
            key: 'createdBy',
            name: t('createdBy'),
            renderCell: ({row}) => `${row.createdBy.name} ${row.createdBy.surname}`
        },
        {
            key: 'createdAt',
            name: t('createdAt'),
            renderCell: ({row}) => moment(row.createdAt).format('DD.MM.YYYY HH:mm')
        },
        {
            key: 'actions',
            name: 'Akce',
            width: 110,
            renderCell: ({row}) => (
                <div className="flex items-center justify-end h-full w-full">
                    <EditIconButton title="Upravit kategorii dílu" onClick={() => openPartCategoryModal(row)}/>
                    <DeleteIconButton title="Smazat kategorii dílu" onClick={() => confirmDeleteCategory(row)}/>
                </div>
            )
        }
    ].map(column => ({...column, resizable: true}));


    const confirmDeleteCategory = async (partCategory) => {
        const result = await confirm(t('confirmCategoryDeletion').replace('{{category}}', partCategory.name), {});
        if (result === true) {
            try {
                await API.delete(API_ENDPOINTS.part.deletePartCategory(partCategory._id));
                setCategories(prevCategories => prevCategories.filter(pc => pc._id !== partCategory._id));
            } catch (error) {
                setError(error);
                console.error("Failed to delete category:", error);
            }
        }
    };

    const openPartCategoryModal = (partCategory) => {
        openModal(PartCategoryModal, {
            partCategory,
            onCategoryAdded: fetchCategories
        }, {title: partCategory ? "Úprava kategorie dílu" : "Nová kategorie dílu"})
    };

    return (
        <div>
            <Forms.Button label={t('addCategory')} onClick={() => openPartCategoryModal()} className="mb-8"/>
            <AdminDataView section="part-categories" rows={categories} columns={columns}/>
        </div>
    );
};

export default PartCategories;
